import {
	SET_GAMES,
	SET_GAME,
	CLEAR_GAMES,
	CLEAR_GAME,
	ADD_GAME,
	UPDATE_GAME,
	REMOVE_GAME,
} from './actionTypes';

export const game = (state = {}, action) => {
	switch (action.type) {
		case SET_GAME:
			return action.payload;
		case UPDATE_GAME:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_GAME:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_GAMES:
			return action.payload;
		case ADD_GAME:
			return [...state, action.payload];
		case UPDATE_GAME:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_GAME:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_GAMES:
			return [];
		default:
			return state;
	}
};
